import { cloneDeep, merge } from "lodash-es";

const CLS_LABEL_SUFFIX = "-label";

const nodeStyleMaps = {};

const baseCfg = {
  nodeStyle: {
    radius: 11,
    height: 48,
    width: 48,
    fill: "#1C66E5",
    lineWidth: 1,
    cursor: "pointer",
  },

  nodeBorder: {
    radius: 13,
    dh: 0,
    dw: 0,
    color: "#ffffff",
  },

  nodeShadow: {
    dt: 10,
    db: 10,
    dl: 12,
    // 右侧，向右扩张 12
    dr: 12,
    color: "transparent",
    // color: "rgba(4, 111, 187, 0.3)",
  },

  buttonGroupConfig: {
    // 水平往左移动 3
    dx: -3,
    // 水平往下移动 4
    dy: -4,
    dh: 10,
    dw: 20,
    fill: "rgba(255, 111, 187, 0.3)",
    // fill: "transparent",
    // 要放置几个按钮
    count: 3,
    splitW: 1, // 分割线宽度
    splitH: 12, // 分割线高度
  },

  activeShadowStyle: {
    shadowBlur: 12,
    shadowOffsetX: 0,
    shadowOffsetY: 6,
    shadowColor: "#12131914",
  },

  iconStyle: {
    width: 28,
    height: 28,
  },

  buttonStyle: {
    width: 18,
    height: 18,
    radius: 5,
    cursor: "pointer",
    // FLOW-DOC:: hover 按钮的间距
    // gap: 4,
    gap: 8,
  },

  buttonBackground: {
    base: "#ffffff",
    hover: "#ddd",
    click: "#eee",
    width: 36,
    height: 36,
    splitLineColor: "#E2EAF7",
    splitLineHeight: 12, // 分割线线条高度
    splitLineWidth: 1,
  },

  bulletStyle: {
    r: 4,
    width: 24,
    height: 12,
    lineWidth: 0,
    stroke: "#4A70FF",
    fill: "#4A70FF",
  },

  errorGroupStyle: {
    dx: -14,
    dy: -12,
    width: 20,
    height: 20,
  },
  buttonIconMaps: {},
};

const nodeCfg = {
  // 基础卡片的样式
  // update: undefined,
  afterDraw(cfg, group) {
    const labelShapeBG = group["shapeMap"]["node-label-bg"];
    const labelShape = group["shapeMap"]["node-label"];
    // labelShape.set("capture", false);
    // labelShapeBG.set("capture", false);
    labelShape.set("zIndex", 100000);
    labelShapeBG.set("zIndex", 100000);
    group.sort();
  },

  hideLabel(group) {
    const labelShape = group["shapeMap"]["node-label"];
    const labelShapeBG = group["shapeMap"]["node-label-bg"];
    labelShapeBG.attr({
      opacity: 0,
    });
    labelShape.attr({
      opacity: 0,
    });
    labelShape.set("zIndex", 0);
    labelShapeBG.set("zIndex", 0);
    group.sort();
    // labelShape.hide();
    // labelShapeBG.hide();
  },
  showLabel(group) {
    const labelShape = group["shapeMap"]["node-label"];
    const labelShapeBG = group["shapeMap"]["node-label-bg"];
    // labelShape.show();
    // labelShapeBG.show();
    labelShape.attr({
      opacity: 1,
    });
    labelShapeBG.attr({
      opacity: 1,
    });
    labelShape.set("zIndex", 100000);
    labelShapeBG.set("zIndex", 100000);
    group.sort();
  },
  drawNodeContent({
    group,
    originX,
    cfg,
    originY,
    nodeData: { nodeType, nodeName, data },
  }) {
    const sCfg = this.getSelfCfg(cfg);
    const contentGroup = group.addGroup({
      id: "node-content",
      zIndex: 400,
    });

    contentGroup.addShape("image", {
      attrs: {
        x: -sCfg.iconStyle.width / 2,
        y: -sCfg.iconStyle.height / 2,
        img: sCfg.icon,
        ...sCfg.iconStyle,
      },
      zIndex: 400,
      capture: false,
    });
  },

  // 根据节点返回需要显示的具体信息
  getNodeContent: (
    type,
    {
      Request, // 询问节点的收集信息
      Response, // API节点的出参
      AnswerType, // 回复节点的答案
      InputAnswerData,
    },
  ) => {
    return `${1}`;
  },

  /**
   * FLOW-DOC: 绘制吸附态时的样式
   */
  drawSelected({ group, originX: x, originY: y, nodeConfig }) {
    // 创建一个包含selected内容的子组
    // const selectedGroup = group.addGroup({ name: "selected-group" });
    // selectedGroup.hide(); // 默认隐藏子组
    // // 绘制边框, g6边框是居中的
    // const { lineWidth, width, height } = sCfg.nodeStyle;
    // selectedGroup.addShape("rect", {
    //   attrs: {
    //     ...sCfg.nodeStyle,
    //     ...this.selectedbStyle,
    //     ...this.activeShadowStyle,
    //     x: x + lineWidth / 2,
    //     y: y + lineWidth / 2,
    //     width: width - lineWidth,
    //     height: height - lineWidth,
    //   },
    //   capture: false,
    // });
  },

  /**
   * FLOW-DOC: 绘制 hover 态时的样式
   */
  drawHover({ group, nodeData: { nodeType }, cfg }) {
    // 创建一个包含hover内容的子组
    // [0,0] 在元素的左上角
    const sCfg = this.getSelfCfg(cfg);
    const originX = 0;
    const originY = 0;
    const hoverGroup = group.addGroup({ name: "hover-group", zIndex: 1000 });

    // 默认隐藏子组
    hoverGroup.hide();

    // FLOW-DOC:
    // 从元素右上角往上 往右画
    // 先画底板
    const overlapMask = sCfg.buttonGroupConfig.dx;
    const buttonGroupWidth =
      sCfg.buttonStyle.width * sCfg.buttonGroupConfig.count;
    const buttonGroupHeight =
      sCfg.buttonStyle.height * 1 + sCfg.buttonGroupConfig.dh;

    const dy =
      sCfg.nodeStyle.height / 2 + sCfg.buttonGroupConfig.dy + buttonGroupHeight;

    const dy2 = sCfg.nodeStyle.height / 2 + sCfg.nodeBorder.dh;

    const dx =
      sCfg.nodeStyle.width / 2 + sCfg.nodeBorder.dw + sCfg.nodeShadow.dr;

    const backGroundX = originX + dx + overlapMask;

    // 计算等分点
    const segmentCount = sCfg.buttonGroupConfig.count;
    const segmentWidth = sCfg.buttonBackground.width;
    const rectX = backGroundX;
    const rectY = originY - dy + sCfg.nodeStyle.height / 2;
    const rectHeight = sCfg.buttonBackground.height;
    const lineWidth = sCfg.buttonBackground.splitLineWidth;
    const lineHeight = sCfg.buttonBackground.splitLineHeight;

    hoverGroup.addShape("rect", {
      attrs: {
        x: backGroundX,
        y: originY - dy + sCfg.nodeStyle.height / 2,
        width:
          sCfg.buttonBackground.width * sCfg.buttonGroupConfig.count +
          lineWidth,
        height: sCfg.buttonBackground.height,
        radius: sCfg.buttonStyle.radius,
        fill: sCfg.buttonBackground.base,
      },
      draggable: true,
      zIndex: 50,
      name: "nodeBase:node-hover-shape",
    });

    // 绘制分割线
    for (let i = 1; i < segmentCount; i++) {
      const lineX = rectX + i * segmentWidth + (i - 1) * lineWidth;
      const lineY = rectY + (rectHeight - lineHeight) / 2; // 垂直居中
      hoverGroup.addShape("line", {
        attrs: {
          x1: lineX,
          y1: lineY,
          x2: lineX,
          y2: lineY + lineHeight,
          stroke: sCfg.buttonBackground.splitLineColor, // 线条颜色
          lineWidth: lineWidth,
        },
        zIndex: 60,
        name: `nodeBase:node-hover-line-${i}`,
      });
    }

    // button 开始坐标
    let buttonX = originX + dx + overlapMask;
    const buttonY = originY - dy;

    this.drawButton({
      hoverGroup,
      x: buttonX,
      y: buttonY,
      name: "edit",
      cfg,
    });
    buttonX = buttonX + sCfg.buttonBackground.width + lineWidth;
    this.drawButton({
      hoverGroup,
      x: buttonX,
      y: buttonY,
      name: "copy",
      cfg,
    });
    buttonX = buttonX + sCfg.buttonBackground.width + lineWidth;
    this.drawButton({
      hoverGroup,
      x: buttonX,
      y: buttonY,
      name: "delete",
      cfg,
    });

    hoverGroup.sort();
  },

  drawSourceBullet({ group, originX, originY, cfg }) {
    const x = originX;
    const labelCfg = cfg.labelCfg;
    const sCfg = this.getSelfCfg(cfg);

    const y2 =
      originY -
      sCfg.nodeStyle.height / 2 -
      sCfg.nodeBorder.dh -
      sCfg.nodeShadow.dt;

    const db1 = labelCfg.offset + labelCfg.style.fontSize / 2;
    const db2 = sCfg.nodeShadow.db;
    const db = db1 > db2 ? db1 : db2;

    const y = originY + sCfg.nodeStyle.height / 2 + sCfg.nodeBorder.dh + db2;

    const hotGroup = group.addGroup({ name: "hot-group", zIndex: 2000 });

    let hotPoints = [
      [x, y],
      [x, y2],
    ];

    // 转人工节点暂时只有一个入口，配置这里之后，就不会有出口
    const {
      nodeData: { nodeType },
    } = cfg;
    if (
      ["transToHumanNode", "endReplyNode", "transToTaskNode"].includes(nodeType)
    ) {
      hotPoints = [[x, y2]];
    }

    // 增加透明的交互区域
    hotGroup.addShape("circle", {
      attrs: {
        x,
        y,
        r: 15, // 交互区域的半径
        fill: "#fff",
        fillOpacity: 0, // 透明
        stroke: "#fff",
        strokeOpacity: 0, // 透明
        cursor: sCfg.nodeStyle.cursor,
        zIndex: 50,
      },
      name: "source-hot-area",
      draggable: true,
      capture: true,
    });

    hotPoints.forEach((p) => {
      const hotArea = hotGroup.addShape("circle", {
        attrs: {
          x: p[0],
          y: p[1],
          r: sCfg.bulletStyle.r,
          fill: sCfg.bulletStyle.fill,
          stroke: sCfg.bulletStyle.stroke,
          lineWidth: sCfg.bulletStyle.lineWidth,
          cursor: sCfg.nodeStyle.cursor,
        },
        name: "anchor-point",
        zIndex: 50,
        capture: true,
        draggable: true,
      });

      hotArea.on("mouseenter", () => {
        // TODO: 动画显示

        hotArea.animate(
          {
            fill: sCfg.bulletStyle.fill,
            r: sCfg.bulletStyle.r + 2,
          },
          {
            callback: () => {
              hotArea.animate(
                {
                  fill: sCfg.bulletStyle.fill,
                  r: sCfg.bulletStyle.r,
                },
                {
                  duration: 300,
                },
              );
            },
            duration: 300,
          },
        );
      });
      hotArea.on("mouseleave", () => {
        hotArea.attr({
          fill: sCfg.bulletStyle.fill,
          r: sCfg.bulletStyle.r,
        });
      });
    });
  },

  drawButton({ hoverGroup, x: _x, y: _y, name, cfg }) {
    const sCfg = this.getSelfCfg(cfg);
    const offsetWidth =
      (sCfg.buttonBackground.width - sCfg.buttonStyle.width) / 2;
    const offsetHeight = sCfg.nodeStyle.height / 2;
    const x = _x + sCfg.buttonStyle.gap;
    const y = _y + offsetHeight;
    const button = hoverGroup.addShape("rect", {
      attrs: {
        x: x - offsetWidth,
        y,
        width: sCfg.buttonBackground.width,
        height: sCfg.buttonBackground.height,
        radius: sCfg.buttonStyle.radius,
        cursor: sCfg.buttonStyle.cursor,
        fill: sCfg.buttonBackground.base,
      },
      zIndex: 100,
      // FLOW-DOC:
      // button:delete
      name: `button:${name}`,
    });
    button.on("mouseenter", () => {
      button.attr({
        fill: sCfg.buttonBackground.hover,
      });
    });
    button.on("mouseleave", () => {
      button.attr({
        fill: sCfg.buttonBackground.base,
      });
    });
    button.on("click", () => {
      button.attr({
        fill: sCfg.buttonBackground.click,
      });
    });

    const icon = hoverGroup.addShape("image", {
      attrs: {
        x,
        y: y + sCfg.buttonStyle.height / 2,
        img: sCfg.buttonIconMaps[name],
        ...sCfg.buttonStyle,
      },
      zIndex: 150,
      name: `${name}-icon`,
      capture: false,
    });

    return { button, icon };
  },

  /**
   * 绘制错误icon
   */
  drawError({ group, originX: x, originY: y, cfg }) {
    // 创建一个包含error内容的子组
    const sCfg = this.getSelfCfg(cfg);
    const errorGroup = group.addGroup({ name: "error-group", zIndex: 8000 });
    errorGroup.hide(); // 默认隐藏子组
    const name = "error";
    errorGroup.addShape("image", {
      attrs: {
        x: x + sCfg.errorGroupStyle.dx,
        y: y + sCfg.errorGroupStyle.dy,
        img: sCfg.buttonIconMaps[name],
        ...sCfg.errorGroupStyle,
        cursor: "default",
      },
      draggable: true,
      name: `${name}-icon`,
      capture: true,
    });
  },

  drawNodeBase({ group, originX, originY, nodeData, cfg }) {
    const labelCfg = cfg.labelCfg;
    const sCfg = this.getSelfCfg(cfg);

    const db1 = labelCfg.offset + labelCfg.style.fontSize / 2;
    const db2 = sCfg.nodeShadow.db;
    const db = db1 > db2 ? db1 : db2;

    const dy2 = originY + sCfg.nodeStyle.height + sCfg.nodeBorder.dh + db2;

    const dy1 = originY - sCfg.nodeShadow.dt - sCfg.nodeBorder.dh;
    const keyShape = group.addShape("polygon", {
      attrs: {
        x: 0,
        y: 0,
        points: [
          // [横轴， 纵轴]
          [originX - sCfg.nodeShadow.dl - sCfg.nodeBorder.dw, dy1],
          // 绘制一个凸槽，包裹 edgeDragPoint
          [
            originX + sCfg.nodeStyle.width / 2 - sCfg.bulletStyle.width / 2,
            dy1,
          ],
          [
            originX + sCfg.nodeStyle.width / 2 - sCfg.bulletStyle.width / 2,
            dy1 - sCfg.bulletStyle.height,
          ],
          [
            originX + sCfg.nodeStyle.width / 2 + sCfg.bulletStyle.width / 2,
            dy1 - sCfg.bulletStyle.height,
          ],
          // 凸槽结束
          [
            originX + sCfg.nodeStyle.width / 2 + sCfg.bulletStyle.width / 2,
            dy1,
          ],
          [
            originX +
              sCfg.nodeStyle.width +
              sCfg.nodeShadow.dr +
              sCfg.nodeBorder.dw,
            dy1,
          ],
          [
            originX +
              sCfg.nodeStyle.width +
              sCfg.nodeShadow.dr +
              sCfg.nodeBorder.dw,
            dy2,
          ],
          // 底部画一个 凸起
          [
            originX +
              sCfg.nodeStyle.width +
              sCfg.nodeShadow.dr +
              sCfg.nodeBorder.dw,
            dy2,
          ],
          [
            originX + sCfg.nodeStyle.width / 2 + sCfg.bulletStyle.width / 2,
            dy2,
          ],
          [
            originX + sCfg.nodeStyle.width / 2 + sCfg.bulletStyle.width / 2,
            dy2 + sCfg.bulletStyle.height,
          ],
          [
            originX + sCfg.nodeStyle.width / 2 - sCfg.bulletStyle.width / 2,
            dy2 + sCfg.bulletStyle.height,
          ],
          [
            originX + sCfg.nodeStyle.width / 2 - sCfg.bulletStyle.width / 2,
            dy2,
          ],
          [originX - sCfg.nodeShadow.dl - sCfg.nodeBorder.dw, dy2],
        ],
        fill: sCfg.nodeShadow.color,
      },
      capture: true,
      draggable: true,
      zIndex: 110,
    });

    // 白色边框
    // group.addShape("rect", {
    //   attrs: {
    //     x: originX - sCfg.nodeBorder.dw,
    //     y: originY - sCfg.nodeBorder.dh,
    //     radius: sCfg.nodeBorder.radius,
    //     height: sCfg.nodeStyle.height + 2 * sCfg.nodeBorder.dh,
    //     width: sCfg.nodeStyle.width + 2 * sCfg.nodeBorder.dw,
    //     fill: sCfg.nodeBorder.color,
    //   },
    //   draggable: true,
    //   zIndex: 120,
    // });
    group.addShape("image", {
      attrs: {
        x: originX - sCfg.nodeBorder.dw,
        y: originY - sCfg.nodeBorder.dh,
        height: sCfg.nodeStyle.height + 2 * sCfg.nodeBorder.dh,
        width: sCfg.nodeStyle.width + 2 * sCfg.nodeBorder.dw,
        img: sCfg.icon,
      },
      draggable: true,
      zIndex: 120,
      name: "nodeBase:node",
    });

    // 绘制底层node
    // group.addShape("rect", {
    //   attrs: {
    //     x: originX,
    //     y: originY,
    //     radius: sCfg.nodeStyle.radius,
    //     height: sCfg.nodeStyle.height,
    //     width: sCfg.nodeStyle.width,
    //     fill: sCfg.nodeStyle.fill,
    //     lineWidth: sCfg.nodeStyle.lineWidth,
    //   },
    //   zIndex: 130,
    //   name: "nodeBase:node",
    //   draggable: true,
    // });

    return keyShape;
  },

  getSelfCfg(cfg) {
    const nodeType = cfg.nodeData.nodeType;
    if (nodeStyleMaps[nodeType]) {
      return nodeStyleMaps[nodeType];
    }

    console.log("init", nodeType, "type style");
    const style = merge({}, baseCfg, this.styleMaps[nodeType]);
    nodeStyleMaps[nodeType] = style;
    return style;
  },
  // G6规定的节点生命周期函数
  draw(cfg, group) {
    // console.log("cfg.nodeData", cfg, group);
    // FLOW-DOC: 节点中心相对鼠标落点的位置
    // 把节点的 中心放在鼠标落点
    const sCfg = this.getSelfCfg(cfg);

    const [originX, originY] = [
      -sCfg.nodeStyle.width / 2,
      -sCfg.nodeStyle.height / 2,
    ];

    // 绘制节点基础, zIndex 从 100 到 399
    const keyShape = this.drawNodeBase({
      group,
      originX,
      originY,
      nodeData: cfg.nodeData,
      cfg,
    });

    // keyShape.on("mouseenter", (e) => {
    //   this.hideLabel(group);
    // });
    // keyShape.on("mouseleave", (e) => {
    //   this.showLabel(group);
    // });

    // FLOW-DOC: 绘制节点里面的内容 zIndex 从 400 到 999
    // this.drawNodeContent({
    //   group,
    //   originX,
    //   originY,
    //   cfg,
    //   nodeData: cfg.nodeData,
    // });

    // FLOW-DOC: zIndex 从 1000 到 1999
    this.drawHover({
      group,
      originX,
      originY,
      nodeData: cfg.nodeData,
      cfg,
    });

    this.drawSourceBullet({ group, originX: 0, originY: 0, cfg });

    // FLOW-DOC: zIndex 从 2000 到 2999
    this.drawError({ group, originX, originY, cfg });

    if (cfg.label) {
      const label = this.drawLabel(cfg, group);
      label.set("className", this.itemType + CLS_LABEL_SUFFIX);
      group["shapeMap"][this.itemType + CLS_LABEL_SUFFIX] = label;
    }
    group.sort();
    return keyShape;
  },

  setState(name, value, item) {
    // selected 属性说明，点击第一次是选中，点击第二次是取消选中，这个行为是默认自带的。
    const group = item.getContainer();
    // G6.Shape.Node.getShape("single-node").setState(name, value, item);
    // console.log(name, value, item);

    if (name === "active") {
      const hoverGroup = group.find(
        (element) => element.get("name") === "hover-group",
      );
      // fix  当重新生成画布时可能存在hoverGroup为空的情况
      if (!hoverGroup) return;
      if (value) {
        item.toFront();
        hoverGroup.show();
        this.hideLabel(group);
      } else {
        item.toBack();
        this.showLabel(group);
        hoverGroup.hide();
      }
    }
    if (name === "selected") {
      //
    } else if (name === "error") {
      const errorGroup = group.find(
        (element) => element.get("name") === "error-group",
      );

      if (value) {
        errorGroup.show();
      } else {
        errorGroup.hide();
      }
    } else if (name === "notAllowed") {
      //
    }
  },

  getAnchorPoints(cfg) {
    const {
      nodeData: { nodeType },
    } = cfg;
    if (["transToHumanNode", "transToTaskNode"].includes(nodeType)) {
      return [[0.5, -0.1]];
    }
    return [
      [0.5, -0.1],
      // [1, 0.5],
      [0.5, 1],
      // [0, 0.5],
    ];
  },
};

export const getCustomNodeCfg = (cfg) => {
  return merge({}, cloneDeep(nodeCfg), cfg);
};
